import React, { useReducer } from 'react';
import { DataContext, initialState, reducer } from '../stores/course-table-store';

const CourseTableContextWrapper = ({ children }) => {
    const [store, dispatch] = useReducer(reducer, initialState);

    return <DataContext.Provider value={{ store, dispatch }}>{children}</DataContext.Provider>;
};

export default CourseTableContextWrapper;
